/**
 * Shared supplier readiness logic.
 *
 * A supplier's public chatbot is gated behind two requirements:
 *  1. Company info is filled (company_name + at least one contact + description/bio)
 *  2. At least one active pricing item exists
 */

export interface SupplierProfile {
  company_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  description?: string | null;
  bot_bio?: string | null;
}

/** True when the supplier has filled basic company information. */
export function hasCompletedSupplierInfo(s: SupplierProfile | null | undefined): boolean {
  if (!s) return false;
  const hasName = !!s.company_name?.trim();
  const hasContact = !!(s.contact_email?.trim() || s.contact_phone?.trim());
  const hasDescription = !!(s.description?.trim() || s.bot_bio?.trim());
  return hasName && hasContact && hasDescription;
}

/** True when the supplier has at least one active price item. */
export function hasConfiguredPricing(hasPriceItems: boolean): boolean {
  return hasPriceItems;
}

/** True when both info and pricing are complete — chatbot can be shown publicly. */
export function isSupplierChatbotReady(
  s: SupplierProfile | null | undefined,
  hasPriceItems: boolean,
): boolean {
  return hasCompletedSupplierInfo(s) && hasConfiguredPricing(hasPriceItems);
}
